import en from './en/en.json';
import enSupportEmailRequests from './en/en.supportEmailRequests.json';
import ka from './ka/ka.json';
import ru from './ru/ru.json';
import uk from './uk/uk.json';

export const translations = {
    en: {
        translation: {...en, ...enSupportEmailRequests}
    },
    ka: {
        translation: {...ka}
    },
    ru: {
        translation: {...ru}
    },
    uk: {
        translation: {...uk}
    },
};
